var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinAmountBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 17,
    viewBox: "0 0 60 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.084,
    x2: -0.279,
    y2: 1.605,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be2121"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-251 -242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 60,
    height: 17,
    rx: 8.5,
    transform: "translate(251 242)",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 36,
    height: 17,
    rx: 8.5,
    transform: "translate(251 242)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_15_",
    "data-name": "15\\u20AC ",
    transform: "translate(268 254)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700,
    opacity: 0.684
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.73,
    y: 0
  }, "15\u20AC ")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinAmountBar);
export default __webpack_public_path__ + "static/media/min-amount-bar.79bbf338f02f73982469edebde0e7e31.svg";
export { ForwardRef as ReactComponent };